export default {
  title: 'Detalhes do pedido',
};
